import _ from 'lodash';
import { round } from '../classes/math.utilities';
import { ISessionHit, ISessionHitStats } from '../interfaces/i-session-hit';

// for reuse between server and front-end to ensure numbers agree
export class SessionHelper {
  static getHitsStats(hits: ISessionHit[]) {
    const safeHits = hits.filter((m) => !m.avg_excluded && !m.hit?.invalid);

    const safeExits = safeHits
      .map((m) => m.hit?.exitMPH)
      .filter((m) => m !== null && m !== undefined) as number[];

    const safeDistances = safeHits
      .map((m) => m.hit?.distanceFT)
      .filter((m) => m !== null && m !== undefined) as number[];

    const safeVLaunches = safeHits
      .map((m) => m.hit?.vLaunchDEG)
      .filter((m) => m !== null && m !== undefined) as number[];

    const output: ISessionHitStats = {
      avgExitMPH: _.mean(safeExits),
      maxExitMPH: _.max(safeExits) ?? 0,
      avgDistanceFT: _.mean(safeDistances),
      maxDistanceFT: _.max(safeDistances) ?? 0,
      avgVLaunchDeg: _.mean(safeVLaunches),
    };

    return output;
  }

  /**
   * Turns hit stat into our desired human readable format.
   * Also handles cases where _.mean (above) returns NaN when it's passed an empty array
   */
  static formatHitStat(
    value?: number,
    config?: { roundTo?: number; fixedTo?: number }
  ) {
    if (!value || isNaN(value)) {
      return '-';
    }

    if (config?.roundTo !== undefined) {
      return round(value, config.roundTo);
    }

    if (config?.fixedTo !== undefined) {
      return round(value, config.fixedTo);
    }

    return value;
  }
}
